import { LOADING_STATUS } from "../actions/types";

const initialState = {
  loading: false,
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_STATUS:
      return { ...state, loading: action.status };
    default:
      return state;
  }
};
export default loaderReducer;
